<template>
  <div class="firstpage">
    <!-- 第一部分 -->
    <img v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/kiamall/pc/kv.jpg'" alt="" />
    <img v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/kiamall/mob/kv.jpg'" alt="" />
    <!-- button -->
    <div class="kv-button" @click="clickKvButton()" code-stm="event, PAGEURL, kv_下载APP_按钮点击"></div>
    <img v-if="!isPortrait" class="kv-qtcode" src="/assets/~/media/images/activity/kiamall/pc/kv-qtcode.png" alt="">

    <!-- 第二部分 -->
    <img  v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/kiamall/pc/kv-2.jpg'" alt="" />
    <img  v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/kiamall/mob/kv-2.jpg'" alt="" />
   
  </div>
</template>

<script>
import { isPortraitFun } from "@/utils/utils.js";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText:'https://www.kia.cn',
    };
  },
  mounted: function () {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    }else{
      this.preText = 'https://www.kia.cn'
    }
  },
  methods: {
    clickKvButton: function () {
      if (this.isPortrait) {
        //mob
        window.open('https://app-web.kia.cn/kia_wap/#/pages/recommendation/register/index?oneId=1008271312312000803', '_blank');
      } else {
        //pc
        return;
      }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.firstpage {
  background-color: rgba(166, 172, 176, 1);
  position: relative;
  // height: calc(2116 / 1920 * 100vw);
  width: 100%;
  user-select: none;
  z-index: 0;
  @media (max-width: 767px) {
    // height: calc(2712 / 750 * 100vw) !important;
  }
  img {
    width: 100%;
    object-fit: cover;
  }
}

@media (min-width: 767px) {
  .kv-button {
    position: absolute;
    top: calc(472 / 1920 * 100vw);
    left: calc(118 / 1920 * 100vw);
    width: calc(260 / 1920 * 100vw) ;
    height: calc(64 / 1920 * 100vw) ;
    background-color: transparent;
    
    cursor: pointer;
    z-index: 1;
  }
  .kv-qtcode {
    position: absolute;
    top: calc(546 / 1920 * 100vw); /* 477 + 64 + 5 (按钮top + 按钮height + 5px) */
    left: calc(152.5 / 1920 * 100vw); /* 118 + (260 - 191) / 2 (按钮left + 居中偏移) */
    width: calc(191 / 1920 * 100vw) !important;
    height: calc(201 / 1920 * 100vw);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 2;
    object-fit: contain;
  }
  .kv-button:hover + .kv-qtcode {
    opacity: 1;
    visibility: visible;
  }
}

@media (max-width: 767px) {
  .kv-button {
    position: absolute;
    top: calc(512 / 750 * 100vw);
    left: calc(76 / 750 * 100vw);
    width: calc(318 / 750 * 100vw);
    height: calc(78 / 750 * 100vw);
    background-color: transparent;
    
  }
}
</style>